/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AncillarySupplierListQuery
 */
export interface AncillarySupplierListQuery {
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof AncillarySupplierListQuery
     */
    carrier?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof AncillarySupplierListQuery
     */
    ancillaryCategory?: Int32IdAndLabel;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof AncillarySupplierListQuery
     */
    ancillary?: GuidIdAndLabel;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof AncillarySupplierListQuery
     */
    supplier?: GuidIdAndLabel;
    /**
     * 
     * @type {number}
     * @memberof AncillarySupplierListQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AncillarySupplierListQuery
     */
    limit?: number | null;
}

export function AncillarySupplierListQueryFromJSON(json: any): AncillarySupplierListQuery {
    return AncillarySupplierListQueryFromJSONTyped(json, false);
}

export function AncillarySupplierListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AncillarySupplierListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'carrier': !exists(json, 'carrier') ? undefined : GuidIdCodeAndLabelFromJSON(json['carrier']),
        'ancillaryCategory': !exists(json, 'ancillaryCategory') ? undefined : Int32IdAndLabelFromJSON(json['ancillaryCategory']),
        'ancillary': !exists(json, 'ancillary') ? undefined : GuidIdAndLabelFromJSON(json['ancillary']),
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdAndLabelFromJSON(json['supplier']),
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function AncillarySupplierListQueryToJSON(value?: AncillarySupplierListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'carrier': GuidIdCodeAndLabelToJSON(value.carrier),
        'ancillaryCategory': Int32IdAndLabelToJSON(value.ancillaryCategory),
        'ancillary': GuidIdAndLabelToJSON(value.ancillary),
        'supplier': GuidIdAndLabelToJSON(value.supplier),
        'offset': value.offset,
        'limit': value.limit,
    };
}


